enum ContractRefundInvoiceStatusTriggers {
  CONTRACT_REFUND_INVOICE_CREATED = 'CONTRACT_REFUND_INVOICE_CREATED',
}
export default ContractRefundInvoiceStatusTriggers;

export type VerifyContractRefundInvoiceStatusTriggers = Utils.VerifyExtends<
  Model.Enum.ContractRefundInvoiceStatusTriggers,
  Utils.ValueOf<typeof ContractRefundInvoiceStatusTriggers>
>;
